<template>
  <v-tabs>
    <template v-for="(opcion, index) in opciones">
      <template>
        <v-tab :key="index" :to="{ name: opcion.ruta }" exact>
          <v-icon small left>
            {{ opcion.icono }}
          </v-icon>
          {{ opcion.nombre }}
        </v-tab>
      </template>
    </template>
  </v-tabs>
</template>

<script>
export default {
  name: 'ControlProyectosOpionesNavegacion',
  data() {
    return {
      opciones: [
        {
          nombre: 'Tablero',
          ruta: 'obraProyectoTablero',
          icono: 'mdi-bulletin-board',
        },
        {
          nombre: 'Documentos',
          ruta: 'obraProyectoDocumentos',
          icono: 'mdi-file-document-outline',
        },
        {
          nombre: 'Validaciones',
          ruta: 'obraProyectoValidaciones',
          icono: 'mdi-file-check-outline',
        },
        // {
        //   nombre: 'Tareas',
        //   ruta: 'obraProyectoTareas',
        //   icono: 'mdi-format-list-checkbox',
        // },
        // {
        //   nombre: 'Calendario',
        //   ruta: 'obraProyectoCalendario',
        //   icono: 'mdi-calendar-blank-outline',
        // },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
